import type { Props as ListItemProps } from '../SortableListItem';

type ItemInfo = {
  item: ListItemProps['itemData'] | null;
  currentPosition: number;
  itemCount: number;
};

const sortableListTranslations = {
  ariaLabel: 'Order items',
  instructions: 'Press Space to reorder',
  itemSelected({ item, currentPosition, itemCount }: ItemInfo) {
    return `${
      item!.name
    }, grabbed. Current position in list: ${currentPosition} of ${itemCount}. Press arrow keys to change position, or Space to drop.`;
  },
  itemMoved({ item, currentPosition, itemCount }: ItemInfo) {
    return `${item!.name}, moved. Current position in list: ${currentPosition} of ${itemCount}.`;
  },
  itemDropped({ item, currentPosition, itemCount }: ItemInfo) {
    return `${item!.name}, dropped. Final position in list: ${currentPosition} of ${itemCount}.`;
  },
};

export type SortableListDefaultTranslations = typeof sortableListTranslations;
export default sortableListTranslations;
